/**
 * Certification Module Constants
 *
 * Centralized configuration values to avoid magic numbers throughout the codebase.
 */

export const CERTIFICATION_CONFIG = {
  /** Minimum certification score (%) to pass the certification test */
  PASSING_SCORE_CERTIFICATION: 70,

  /** Maximum number of certification attempts allowed per case */
  MAX_ATTEMPTS: 3,

  /** NOTE: Case completion (100% slides visited) is required to unlock certification */
} as const satisfies Record<string, number>;

export type CertificationConfig = typeof CERTIFICATION_CONFIG;
